export default {
  PriceUnit: 'US$',
	IndexNavbar: {
		HomePage: "Home",
		Founder: "Founder",
		Artwork: "Artworks",
		Pieces: "Pieces",
		Artists: "Artists",
		PrivateArtSteward: "Art Advisors",
		BusinessModelCase: "Business Model",
		Photo: "Activities",
		LatestNews: "Latest News",
		AboutUs: "About Us",
		RecommendArtwork: "Recommend Artworks",
		RecommendArtists: "Recommend Artists",
		JumpLink: "Related Videos",
		NewsDetail: 'News details'
	},
	IndexAboutUs: {
		AboutUs: "About Us",
		Introduce: "KingsArts aim to create Chinese contemporary art trading platform. Our professional art advisor will search and explore potential artworks throughout China. Introducing high-quality original artworks to the world and set out world class standard in Chinese art industry.",
		Address: "Address: Room 97, 2/F, Eton Tower, 8 Hysan Avenue, Causeway Bay, Hong Kong",
		Tel: "Tel: +852 2882 3279"
	},
	FooterNavbar: {
		Artwork: "Artworks",
		Artists: "Artists",
		PromoteSales: "Promote Sales",
		PromoteManager: "Promote Manager",
		SecondSale: "Second Sale",
		SalesCase: "Sales Case",
		SiteName: "KingsArts",
		AboutUs: "About Us"
	},
	Founder: {
		SendWord: "Dr. Wong's message",
		SendWordMsg1: "Living in art is colorful, without art life becomes dull.",
		SendWordMsg2: "Living in art wins it all, otherwise life struggles.",
		Founder: "Dr. Raymond Wong",
    TakeOffice1: "Champ Pro Management Ltd.",
    TakeOffice2: "King Art Holding Company Ltd.",
    TakeOffice3: "Hi-Me Transformation Ltd.",
    TakeOffice4: "Kau Chi Society of Chinese Art",
    TakeOffice5: "The Hong Kong Polytechnic University",
    TakeOffice6: "The Hong Kong Polytechnic University (CEO Club)",
    TakeOffice7: "New Asia College, The Chinese University of Hong Kong",
    TakeOffice8: "«Mirror» Magazine (2011- Present)",
    TakeOffice9: "CEO Club, The Hong Kong Polytechnic University (2010- Present)",
    TakeOffice10: "Hong Kong Tsuen Wan Industries and Commerce Association Ltd.(2008- Present)",
    TakeOffice11: "Hong Kong Asia Lions Club (2006- Present)",
    TakeOffice12: "Corporate Coaching Association (2006- Present)",
    TakeOffice13: "World Outstanding Chinese Association (2004- Present)",
    TakeOffice14: "Life Underwriter & Sales Executive Board (HK) Ltd (LUSEB)(1991)",
    TakeOffice15: "Life Underwriter & Sales Executive Board (HK) Ltd (LUSEB)(1992- Present)",
    Position1: "Chairman",
    Position2: "Chairman",
    Position3: "Chairman",
    Position4: "Vice President",
    Position5: "Honorary Life Vice President",
    Position6: "Executive Vice President",
    Position7: "Board of Trustee",
    Position8: "Advisor",
    Position9: "Member of Council",
    Position10: "Board Member",
    Position11: "1st Vice Chairman",
    Position12: "Founder Chairman",
    Position13: "Founder Chairman",
    Position14: "Ex-Chairman",
    Position15: "Board of Director",
		Story1: `The Chairman of Champ Pro Management Limited, with more than 3,500 financial planning consultants, the Champ Family Team, includes 24 Senior District Directors and District Directors. In 2021, Dr Wong achieved a Lifetime Achievement Award at Asia Trusted Life Agents & Advisers Award. Besides, Dr Wong is a Member of the Board of Trustees to New Asia College in Chinese University Hong Kong and Executive Vice President to CEO Club in Polytechnic University. Dr Wong is the Founder of World Outstanding Chinese Association Limited. His specialty is focus on Human Capital Development and an adviser with governmental projects. Dr Wong is an Antique collector and loves the Arts of Bonsai during his spare time. In 2018, he graduated from Tsinghua University School of Fine Arts - Tsinghua University School of Economics and Management - Sotheby's School of Art, Master of Art Management.`,
		Story2: "Photo taken with Mr. C.Y. Leung ",
		Story3: "APEA 2015",
		Story4: "Dr Wong and the Chief Executive of HKSAR, Mrs Carrie Lam",
		Story5: "Speech at 'The Mirror' 2017",
		Story6: "Photo taken with Mr Henry Hu",
		Story7: "2004 accepted the President's award for quality education and delivered a speech at the ceremony",
		Story8: "Dr. Huang will graduate from Sotheby's School of art - Master of Art Management, at Tsing Hua University in March 2019",
		Story9: "Photo taken with Mr. Chui Sai On",
		Story10: "Presenting guest with Mr C.Y. Leung at 'The Mirror'",
		Story11: "Photo taken with Henry Tang",
	},
	PrivateArtSteward: {
		ArtSteward: "KingsArts Art Advisor",
		Content1:"",
		Content2: "Responsibilities and Work Guidelines",
		Content3: "1. Focus on four galleries or artists and fully understand the creative concept and value of each artwork.",
		Content4: "2. Help art collectors to understand the works of the artists they represented.",
		Content5: "3. Provide professional service to the art collectors during the purchase process.",
		Content6: "4. Professional follow up after sales.",
		Content7: "5. Close encounter with potenial artists.",
		Content8: "6. Your personal contact will be better expanded.",
		Content9: "7. Get professional art training and marketing strategy.",
		Content10: "8. Opportunities to participate art study tours around the world.",
		Content11: "",
		Content12: "",
		Content13: "",
		Content14: "",
	},
	BusinessModel: {
		Amateur: "Art collector",
		AmateurUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business1_en.png",
		Artists: "Artist",
		ArtistsUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business2_en.png",
		ArtSpecialist: "Art Professional",
		ArtSpecialistUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business3_en.png",
		PrivateArtSteward: "Executive Art Advisor",
		PrivateArtStewardUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business4_en.png",
		ArtPromotionManager: "Art Advisor",
		ArtPromotionManagerUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business5_en.png",
		ModelCase: "Case Studies"
	},
	AboutUs: {
		Clauses: "KingsArts Mission Statement",
		Clauses1: "Create bridge between artists and collectors",
		Clauses2: "Discover and promote Chinese contemporary art",
		Clauses3: "Integrate art into everyone's daily life",
		Clauses4: "",
		SharedValues: "KingsArts Core Values",
		Challenge : "",
		Activitier: "",
		Acknowledgement: "",
		Aesthetic: "",
		Value: "KingsArts Personal Art Advisor",
		CompanyProfile: "Company Profile",
		CompanyProfile1: "KingsArts is an art management group based in Hong Kong" ,
		CompanyProfile2: "We have a unique art promotion team, innoative is our driving force to promote Chinese contemporary art. ",
		CompanyProfile3: "",
		CompanyProfile4: "",
		CompanyProfile5: "",
		CompanyProfile6: "",
		Management: "The Management Team",
		Name: "Dr. Raymond Wong",
		position: "Founder - President",
		Resume: "The Chairman of Champ Pro Management Limited, with more than 3,500 financial planning consultants, the Champ Family Team, includes 24 Senior District Directors and District Directors. In 2021, Dr Wong achieved a Lifetime Achievement Award at Asia Trusted Life Agents & Advisers Award. Besides, Dr Wong is a Member of the Board of Trustees to New Asia College in Chinese University Hong Kong and Executive Vice President to CEO Club in Polytechnic University. Dr Wong is the Founder of World Outstanding Chinese Association Limited. His specialty is focus on Human Capital Development and an adviser with governmental projects. Dr Wong is an Antique collector and loves the Arts of Bonsai during his spare time. In 2018, he graduated from Tsinghua University School of Fine Arts - Tsinghua University School of Economics and Management - Sotheby's School of Art, Master of Art Management.",
		Name1: "Ms.Bonnie Leung",
		position1: "President, Marketing",
		Resume1: "Bonnie Leung has over 10 years of multinational corporate management experience and is an expert in optimization of operational efficiency through automation. Ms. Leung is responsible for KingsArts’ marketing, through digital marketing and online education, we help overseas art enthusiasts understand contemporary Chinese art, break geographical boundaries and connect global audience through the power of art and unleash the unique charm of art at international market!",
		Name2: "Lawyer Jackie Cheung",
		position2: "Executive Director and Chief Legal Officer",
		Resume2: "Art collector, currently a practicing lawyer in Hong Kong (1995-present), Assistant Vice President of Kaiji Securities Asia Limited (2011-present), Independent Non-executive Director of Hong Kong-listed Huineng Group (01539.HK) (2015-present) and Wealth Management Manager of AIA (2015-present), Served as a District Councillor of the Central and Western District Councils of Hong Kong (2008-2015). Zhang believes that the works of art, in addition to cultivating the lover's temperament, also witnessed the achievements of ancient and modern artists, and through the transaction and circulation of the then-carved art and culture collection, preservation and inheritance. He hoped that art stakeholders and enthusiasts can learn more about art, exchange art, preserve art, promote the development and inheritance of art and culture through the platform of the Association of Arts and Crafts.",
		Name3: "Yan Zhong",
		position3: "Art Director",
		Resume3: "Yan has been working in art galleries and in the local art industry for years. She has organized and participated in many art exhibitions and shared her experiences with public audiences in order to lead the public interest in art. She also helps artists to build their foundation of art career path.",
		Name4: "Dr. Michael Wong",
		position4: "Executive Director and Chief Executive Officer",
		Resume4: "Art collector of Chinese Contemporary Arts, now is currently the District Director of AIA International Limited, the Executive Director and Chief Executive Officer of KingsArts, the Executive Director of King Art Holding Company Limited, the Executive Director of HKEW Arts and Cultural Exchange Association Limited. Mr Wong is specially love the works of Chinese Contemporary Arts, particularly ink printing. He’s really hope to contact more Art Lovers, Art Collectors and potential young Artists in worldwide, through the KingsArts platform to establish the communications and relationships. Discover more unique, special and historic valuable art collections, rise the long-term development of Chinese Contemporary Arts in Hong Kong.",
		Name5: "Ms.J.J. Wang",
		position5: "Managing Director, Partner",
		Resume5: "Ms. Wang has over 10 years of experience in the collection, investing and promotion of contemporary artwork. She is responsible for the strategic development and daily operations of Kings Arts, leveraging Hong Kong as an international platform to integrate Chinese contemporary art with the global market. In her role, Ms. Wang is keen on ushering in the charm of China on the international stage with her in-depth services and support for Chinese contemporary artists and artworks.“Opening the door for Chinese artists to walk into the gloabl art world. ”",
		Name6: "Henry Law",
		position6: "Market Development Director",
		Resume6: "Graduated from the Department of Computer Science, University of Western Ontario, Canada, he is a senior network technology expert. He once led a company under his name to win an annual award at Microsoft. He successfully introduced strategic investors such as listed companies in Australia and the United States, and Singaporean venture funds, resulting in multiple corporate mergers and acquisitions. His investments include listed companies in the United States, the blockchain ecosystem and digital asset management platforms. Apart from technology, he is also a well-known business psychology coach, responsible for team sales training.",
		Name7: "Yan Zhong",
		position7: "Art Executive Director",
		Resume7: "She studied art courses at the Hong Kong University and the Chinese University of Hong Kong. She worked in Hong Kong's art galleries as an art project manager. Participated in the planning and co-ordinating many art exhibitions, assisted artists to participate in major art fairs.",
		Marketplace: "Our Art Market",

    aboutUrl1: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_1_en.jpg',
    aboutUrl2: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_2_en.jpg',
    aboutUrl3: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_3_en.jpg',
    aboutUrl4: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_4_en.jpg',
    
	},
	// 漏掉的翻译
	LastTranslate: {
		Name1: "KingsArts",
		Name2: "Contemporary Art Trading Platform",
		title1: 'How to become an "Art Advisor"',
		title2: 'How to register',
		title3: "KingsArts Platform",
		title4: "KingsArts Platform",
    Address: "Email: info@kingsarts.com",
    Tel: "",
		All: "All",
		AllLabel1: "Listing",
		AllLabel2: "Time Sort",
		ScreenMenu: "Sort",
		ScreenTitle1: "Potential Artwork",
		ScreenTitle2: "Price",
		ScreenTitle3: "Size",
		ScreenTitle4: "Theme Color",
		ScreenTitle5: "Shape",
		ScreenTitle6: "Placing space",
		Attribute: "Attribute",
		AttributeName: "Work Name ",
		AttributeAtr: "Artist",
		AttributeDate: "CreativeTime",
		AttributeMaterial: "Material",
		AttributeSize: "Szie",
		WorksDetails: "Works Details",
		RecommendedWorks: "",
		ExpertsEvaluation: "Expert Comments",
		ArtInfo: "Artist Column",
		ArtWorks: "Artworks",
		ArtIntroduced: "Artist Introduction",
		ArtCV: "Artist Info",
		ArtCV1: "Solo exhibition",
		ArtCV2: "Group exhibition",
		ArtCV3: "Gallery exhibition",
		ArtCV4: "Awards",
		Challenge: "挑戰自我",
		Activitier: "活動韻律",
		Acknowledgement: "修身養性",
		Aesthetic: "返璞歸真",
		ICP: "All Rights Reserved",
		ICP1: "粤ICP备20032099号",

		PayOur: 'Follow us',
		ContactPhone: 'Phone',
		CustomerService: 'Customer service',
		ContactUs: 'Contact us',
		LegalNotices: 'Legal notices',
		generalLaw: 'Terms and Conditions',
		butlerManagement: '',
		SellerManagement: '',
		Who: 'Who are we?',
		AboutUs: 'About us',
		OurArtist: 'Our artist',
		OurTeam: 'Our team',
		QA: 'FAQ',
		Contact: 'Contact',
		FOOfTitle1: 'Are you an artist / gallery / collector',
		FOOfTitle2: 'KingsArts on IOS / Android',
		ScanCodeTips1: 'Scan QR code to download the app of the seller of KingsArts',
		ScanCodeTips2: 'Join KingsArts',
		ScanCodeTips3: 'Buy Now',
		ScanCodeTips4: 'Become our Art Advisor',

		SittingRoom: "Living Room",
		Bedroom: "Bedroom",
		Outdoor: "Outdoor",
		PublicHall: 'Hall',
		NoMore: 'no more',
		registrationAgreement: 'Registration Agreement',
		Download: 'Download',
		
		website: 'website',
		Below: 'Below 3000',
		Above50000: 'Above 50000',
		Above200: 'Above 200'
	},
	ArtworkDetail: {
		Excellent: "Potential Artwork",
		Code: "Code",
		PriceTips: "Included Shipping Cost",
		References: "References",
		ProductNumber: "Product Number",
		ArtworkName: "Artwork Name",
		ArtworkType: "Artwork Categories",
		Artists: "Artists",
		CreateTime: "Create Time",
		Material: "Material",
		Size: "Size",
		ThemeColor: "Theme Color",
		Red: "Red",
		Green: 'Green',
		Blue: 'Blue',
		Yellow: "Yellow",
		Gray: 'Gray',
		Other: "Other",
		Square: 'Square',
		Rectangle1: 'Rectangle (horizontal)',
		Rectangle2: 'Rectangle (vertical)',
		Roundness: 'Roundness',
		OtherShapes: 'Other shapes',
		Shape: "Shape",
		Price: "Price",
		Seller: "Seller",
		TransactionHistory: "Transaction History",
		Time1: "第",
		Time2: "次",
		ArtworkDetails: "Artwork Details",
		Comments: "Comments",
		ArtworkInformation: "Artwork Information",
		ArtCritics: "Art Critics",
		Details: "Details",
		ArtistProfile1: "Artist Profile",
		ArtistProfile2: "Artist Introduction",
		SoloExhibitions: "Solo Exhibition",
		GroupExhibitions: "Group Exhibition",
		PavilionExhibitions: "Gallery Exhibition",
		Awards: "Awards",
		SeeAll: "Artist Profile",
		TakeBack: "Take Back",
		MoreData: "No More Data",
		Recommendations: "Recommendations",
		ArtistWorks: "Artist Works",
		sold: "Sold",
		withdrawn: "Withdrawn",
		Next: "Next",
		Previous: "Previous",
		Home: "Home",
		ArtworkName: "Artwork Name",
		Material: "Material",
		CreateTime: "Create Time",
		download: "Download",
		viewArt: "View artist's home page＞",
		how :"A total of",
		artworks: "Artworks",
		works: "Works",
		Pieces: "Pieces",
		EnterName: "Enter Artwork name",
		EnterArtName: "Enter the name of the Artist",
		Unlimited: "Unlimited",
		select: "select",
		ALL: "ALL",
		DefaultSort: "Listing",
		TimeSort: "Time Sort",
		Sort:"Sort",
		Reset: "Reset",
		Confirm: "Confirm",
		ArtistInfo: "Artist Info",
		ArtistResume: "Artist Resume",
		NoMore: "— Not more Data —",
		Loading: "Loading",
		Refresh: "Refresh successful",
		PullingText: "Drop-down to refresh",
		LoosingText: "Release to refresh",
		Message: "Chairman Message",
		What: 'What is a "Secondary Transaction"',
		How: 'How to become a "Art Advisor"'
	},
	// 邀请注册
	Register: {
		Title: "Invite you to join KingsArts",
		NameBar1: "Art Advisor",
		Reg: "Sign up now",
		MobilePla: "Please enter your mobile phone number",
		nickNamePla: "Please enter your Name",
		emailPla: "Please enter your E-mail",
		VCodePla: "Please enter the verification code",
		VCodeBtn: "Get Code ",
		PwdPla: "Please enter your password",
		SubmitBtn: "Agree and register",
		RidaoBtn: "I agree",
		Agreement: "《Service Agreement》",
		Radio: "Please check the Service Agreement",
		Success: "Verification code sent successfully",
		PwdPlaErr: "Wrong password",
		Countries: "Area",
		smsCode: "Please select the area code",
		videoTitle: "KingsArts",
		videoTitle2: "What is Art Advisor",
		videoTitle3: "What is Art",
		hot: "Popular Regions",
		all: "All regions",
		videoText: "KingsArts.com is an art trading platform",
		downLoad: 'Download'
	}
}
